/* ALUZA · scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-hero, .mt-scale');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initComparador() {
    document.querySelectorAll('.mt-cmp').forEach(function (box) {
      var range = box.querySelector('input[type=range]');
      if (!range) return;
      var set = function (v) { box.style.setProperty('--mt-pos', v + '%'); };
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
      if (!reduce && 'IntersectionObserver' in window) {
        var played = false;
        new IntersectionObserver(function (en, o) {
          if (en[0].isIntersecting && !played) {
            played = true; o.disconnect();
            var t0 = null;
            var run = function (t) {
              if (!t0) t0 = t;
              var p = Math.min((t - t0) / 1600, 1);
              var v = 50 + Math.sin(p * Math.PI * 2) * 32 * (1 - p * 0.4);
              range.value = v; set(v);
              if (p < 1) requestAnimationFrame(run); else { range.value = 50; set(50); }
            };
            requestAnimationFrame(run);
          }
        }, { threshold: 0.5 }).observe(box);
      }
    });
  }

  function initPasos() {
    document.querySelectorAll('[data-mt-pasos]').forEach(function (root) {
      var steps = root.querySelectorAll('.mt-step');
      var imgs = root.querySelectorAll('.mt-pasos__stage img');
      if (!steps.length) return;
      var activate = function (i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      };
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) activate(Array.prototype.indexOf.call(steps, en.target));
        });
      }, { rootMargin: '-40% 0px -40% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-mt-count]');
    if (!els.length) return;
    var run = function (el) {
      var end = parseFloat(el.getAttribute('data-mt-count'));
      var dec = (el.getAttribute('data-mt-count').split('.')[1] || '').length;
      if (reduce || isNaN(end)) { el.textContent = fmt(end, dec); return; }
      var t0 = null, dur = 1800;
      var tick = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(end * e, dec);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    var fmt = function (v, d) { return Number(v).toLocaleString('es-MX', { minimumFractionDigits: d, maximumFractionDigits: d }); };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }


  /* ---- limpieza tipográfica de la ficha (emojis y etiquetas de Globo) ---- */
  var EMOJI = /[\u{1F000}-\u{1FAFF}\u{2300}-\u{23FF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]+/gu;
  var CLEAN_SEL = '.product__title, .product__description, .aluza-ds__pane, .aluza-desc-rest, .gpo-container, .accordion__content, .card__heading, .cart-item__name, .product__text, .aluza-delivery, .aluza-toggle-btn, .aluza-status';
  var UPLOAD_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V5M7 10l5-5 5 5M5 19h14"/></svg>';
  function cleanNode(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { if (EMOJI.test(n.nodeValue)) list.push(n); EMOJI.lastIndex = 0; }
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(EMOJI, '').replace(/[  ]{2,}/g, ' ').replace(/\s+([.,;:!?])/g, '$1').replace(/^\s+(?=\S)/, function (m) { return t.previousSibling ? m : ''; }); });
  }
  function tidyProduct() {
    document.querySelectorAll(CLEAN_SEL).forEach(cleanNode);
    document.querySelectorAll('.gpo-label').forEach(function (l) {
      if (/personaliza/i.test(l.textContent)) l.classList.add('mt-gpo-title');
    });
    document.querySelectorAll('.aluza-upload-pill-icon').forEach(function (i) { if (!i.querySelector('svg')) i.innerHTML = UPLOAD_ICON; });
  }
  function initProductTidy() {
    if (!document.querySelector('.product__info-container')) return;
    tidyProduct();
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; mo.disconnect(); tidyProduct(); mo.observe(document.body, { childList: true, subtree: true, characterData: false }); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }


  /* ---- artículos: índice automático y tiempo de lectura ---- */
  function initArticulo() {
    var c = document.querySelector('.article-template__content');
    if (!c || c.dataset.mtToc) return; c.dataset.mtToc = '1';
    var words = (c.textContent || '').trim().split(/\s+/).length, mins = Math.max(1, Math.round(words / 200));
    var meta = document.querySelector('.article-template header .caption-with-letter-spacing');
    var head = document.querySelector('.article-template header');
    if (head) { var s = document.createElement('span'); s.className = 'circle-divider caption-with-letter-spacing'; s.textContent = mins + ' min de lectura'; (meta ? meta.parentNode : head).appendChild(s); }
    var hs = c.querySelectorAll('h2');
    if (hs.length < 3) return;
    var used = {};
    var list = [].map.call(hs, function (h, i) {
      var id = h.id || (h.textContent || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || ('seccion-' + (i + 1));
      if (used[id]) id += '-' + (i + 1); used[id] = 1; h.id = id;
      return '<li><a href="#' + id + '">' + h.textContent + '</a></li>';
    }).join('');
    var nav = document.createElement('nav'); nav.className = 'mt-toc'; nav.setAttribute('aria-label', 'En esta guía');
    nav.innerHTML = '<p class="mt-toc__t">En esta guía</p><ol>' + list + '</ol>';
    var firstH2 = hs[0]; firstH2.parentNode.insertBefore(nav, firstH2);
  }

  /* ---- video nativo de la ficha: se descarga y reproduce solo al verse ---- */
  function initNativeVideo() {
    var vids = document.querySelectorAll('video.aluza-native-video, video[data-mt-lazy]');
    if (!vids.length) return;
    var play = function (v) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !reduce) { play(en.target); }
        else if (!en.target.paused) { en.target.pause(); }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() { initNativeVideo(); initReveal(); initComparador(); initPasos(); initCifras(); initProductTidy(); initArticulo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
